import { useContext, useEffect, useState } from "react";
import { useHistory, useLocation } from "react-router";
import { login } from "../../context/actions/auth/login";
// import { loginToken } from "../../context/actions/auth/loginToken";
import { GlobalContext } from "../../context/Provider";

const useForm = () => {
  const [form, setForm] = useState({});

  const history = useHistory();

  const search = useLocation().search;
  const token = new URLSearchParams(search).get("token");

  const {
    authDispatch,
    authState: {
      auth: { loading, error, data },
    },
  } = useContext(GlobalContext);

  // El prefijo "_" es porque no se utiliza este parámetro en la función, pero ocupa su lugar
  const onChange = (_e, { name, value }) => {
    setForm({ ...form, [name]: value });
  };

  const onSubmit = () => {
    login(form)(authDispatch);
  };

  useEffect(() => {
    if (data && sessionStorage.token) {
      history.push("/pendientes");
    } else if (token) {
    //   loginToken(token)(authDispatch);
    }
    // eslint-disable-next-line
  }, [data]);

  const LoginFormValid = form.username?.length && form.password?.length;

  return { form, onChange, loading, error, LoginFormValid, onSubmit };
};

export default useForm;
